import { z } from 'zod';

const userGuideBasePath = 'user-guide-agent/v1/';

const messageSchema = z.object({
  role: z.enum(['user', 'assistant']),
  content: z.string(),
});

export type Message = z.infer<typeof messageSchema>;

const userGuideAssetSchema = z.object({
  tag: z.string(),
  name: z.string(),
  asset_class: z.string().optional(),
  provenance: z.string(),
});
export type UserGuideAsset = z.infer<typeof userGuideAssetSchema>;

const userGuideThemeSchema = z.object({
  id: z.string(),
  name: z.string(),
});
export type UserGuideTheme = z.infer<typeof userGuideThemeSchema>;

const userGuideGeographySchema = z.object({
  code: z.string(),
  name: z.string(),
});
export type UserGuideGeography = z.infer<typeof userGuideGeographySchema>;

const profileSchema = z.object({
  assets: z.array(userGuideAssetSchema).nullable(),
  themes: z.array(userGuideThemeSchema).nullable(),
  geos: z.array(userGuideGeographySchema).nullable(),
});

const coverageSchema = z.object({
  assets: z.number(),
  themes: z.number(),
  geos: z.number(),
  sufficient: z.boolean(),
});

export const userGuideInterviewResponseSchema = z.object({
  profile: profileSchema,
  coverage: coverageSchema,
  next_question: z.string(),
  done: z.boolean(),
});

export type UserGuideInterviewResponse = z.infer<
  typeof userGuideInterviewResponseSchema
>;

export const userGuideAgent = {
  postInterview: {
    path: `${userGuideBasePath}interview`,
    schema: userGuideInterviewResponseSchema,
  },
};
